import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import ProductItem from '../../Category/ProductItem';
import Pagination from '../../../hocs/Pagination/Pagination';
import { unique, shuffle } from '../../../utils/array';
import s from './Products.scss';

const emptyArray = [];

const Products = ({ setup, productCache, content = {}, attrs = {}, depth = false }) => {
	if (!productCache || !productCache[setup.market] || !productCache[setup.market][setup.pricelist] || !content) return null;

	let completeProductList = [];
	const cache = productCache[setup.market][setup.pricelist];
	const classes = [s.products];

	if (attrs.align === 'full') classes[classes.length] = s.products__alignFull;
	if (depth === 1 && attrs.align !== 'full') classes[classes.length] = s.products__top;

	if (content.individual) {
		completeProductList = [...completeProductList, ...content.individual];
	} else if (content.category) {
		content.category.forEach((category) => {
			// Uses default en
			completeProductList = [...completeProductList, ...(cache.filterArrays.categoryVariants[category.default] ? cache.filterArrays.categoryVariants[category.default] : [])];
		});
	} else if (content.campaign) {
		content.campaign.forEach((campaign) => {
			completeProductList = [...completeProductList, ...((campaign.value && cache.filterArrays.campaigns[campaign.value]) || [])];
		});
	} else if (content.collection) {
		content.collection.forEach((collection) => {
			completeProductList = [...completeProductList, ...((collection && cache.filterArrays.collections[collection]) || [])];
		});
	} else if (content.brand) {
		content.brand.filter((b) => !!b).forEach((brand) => {
			completeProductList = [...completeProductList, ...((brand && cache.filterArrays.designers[brand]) || [])];
		});
	}

	completeProductList = completeProductList.reduce((acc, id) => [...acc, ...Object.keys(cache.products).filter((cacheID) => cacheID.indexOf(id) !== -1)], []);
	completeProductList = unique(completeProductList);

	if (content.limit !== undefined) {
		completeProductList = completeProductList.slice(0, parseInt(content.limit, 10));
	}

	return (
		<div className={classes.join(' ')}>
			<Pagination variantClasses={content.perRow ? [`productItem__perRow_${content.perRow}`] : emptyArray} imageColumn={content.perRow ? undefined : '4'} ListComponent={ProductItem} list={completeProductList} cache={productCache[setup.market][setup.pricelist].products} currentPath="" canonical useFlatImages={content.variation === 'flat'} />
		</div>
	);
};

const mapState = ({ environment, productCache }, props) => ({
	setup: environment.setup,
	productCache,
	...props,
});

export default hot(module)(connect(mapState)(Products));
